import React from 'react';
import Styles from './tab-header-title-styles.scss';
const TabHeaderTitle = ({ icon, title }) => {
    return (React.createElement("div", { className: Styles.tabHeaderTitleWrap },
        icon ? React.createElement("div", { className: Styles.iconWrap }, icon) : null,
        React.createElement("h3", { className: Styles.title }, title)));
};
export default TabHeaderTitle;
